import { StoreConstants } from '@/types';
import { NavigationState } from '@/types/store/navigation';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<NavigationState> = {
  [StoreConstants.Navigation.Mutations.SetDocumentViewBackRoute](state, { route, label, params }: { route: string; label: string | null; params: Record<string, any> | null }) {
    state.documentViewBackRoute = route;
    state.documentViewBackRouteLabel = label;
    state.documentViewBackRouteParams = params;
  },
  [StoreConstants.Navigation.Mutations.ClearDocumentViewBackRoute](state) {
    state.documentViewBackRoute = null;
    state.documentViewBackRouteLabel = null;
    state.documentViewBackRouteParams = null;
  }
};
